import { useIsTextTruncated } from '@components/v2/form/_components/ChipList/hooks/useIsTextTruncated';
import Typography from '@components/v2/ui/Typography/Typography';

interface AutocompleteOptionLabelProps {
  label: string;
}

const AutocompleteOptionLabel = ({ label }: AutocompleteOptionLabelProps) => {
  const { setElement, isTruncated } = useIsTextTruncated<HTMLElement>();

  return (
    <Typography
      noWrap
      ref={setElement}
      component="span"
      variant="inherit"
      title={isTruncated ? label : undefined}
      sx={{ minWidth: 0 }}
    >
      {label}
    </Typography>
  );
};

export default AutocompleteOptionLabel;
